import React from 'react'

const WorkInProgressPage = () => {
    return (
        <div>WorkInProgressPage</div>
    )
}

export default WorkInProgressPage